<template>
  <Navbar v-if="isMerchantValidated()" />
  <div class="app-wrapper">
    <router-view />
    <Footer />
  </div>
  <Loader v-show="loading" />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Loader from "@/components/Loader.vue";
import { emitter } from '@/services/emitter.service';

export default {
  components: {
    Navbar,
    Footer,
    Loader
  },
  data() {
    return { loading: false };
  },
  created() {
    emitter.on("showLoader", (e) => {
      this.loading = e;
    });
  },
  methods: {
    isMerchantValidated() {
      return localStorage.getItem("merchant") != undefined;
    },
  },
};
</script>